<template>
    <div>
        <div v-if="loading" class="loading"></div>
        <b-form @submit="onSubmit">
            <b-form-group
                    id="input-name"
                    label="Заголовок"
                    label-for="name"
                    description=""
            >
                <b-form-input
                        id="input-1"
                        v-model="item.name"
                        type="text"
                        required
                        placeholder="Name"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="select-category"
                    label="Категория"
                    label-for="category"
            >
                <b-form-select v-model="item.category_id">
                    <b-form-select-option :value="0">Не выбран</b-form-select-option>
                    <b-form-select-option id="category" :key="index" v-model="category.v1c_id" v-for="(category, index) in categories" >{{ category.name }}</b-form-select-option>
                </b-form-select>
            </b-form-group>


            <p v-if="item.banner">
                <img :src="this.axios.defaults.baseImageURL + item.banner" class="image-cart" alt="">
            </p>
            <input type="file" id="banner" ref="banner" v-on:change="handleFileUpload()"/>

            <div class="buttons">
                <b-button type="submit" variant="primary">Submit</b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
    export default {
        name: "AdminBannerInsert",
        data() {
            return {
                item: {
                    'category_id': 0
                },
                banner: null,
                categories: [],
                loading: false
            }
        },

        mounted() {
            this.axios
                .get(this.axios.defaults.baseURL + 'admin/categories')
                .then(response => {
                    this.categories = response.data.categories;
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                this.loading = false
            })

            if (this.$route.params.id) {
                this.loading = true
                this.axios
                    .get(this.axios.defaults.baseURL + 'admin/stocks/' + this.$route.params.id,)
                    .then(response => {
                        this.item = response.data.item
                    })
                    .catch(error => {
                        console.log(error);
                    }).finally(() => {
                    this.loading = false
                })
            }
        },

        methods: {
            onSubmit(evt) {
                evt.preventDefault()
                let formData = new FormData();
                formData.append('banner', this.banner);
                formData.append('name', this.item.name);
                formData.append('category_id', this.item.category_id);

                if (!this.$route.params.id) {
                    this.axios
                        .post(this.axios.defaults.baseURL + 'admin/stocks', formData)
                        .then(response => {
                            if (response.data.message === 'success'){
                                this.$router.push({name: 'AdminBanner',  params: {message: 'Успешно добавлено'}})
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        })
                } else {
                    formData.append('_method', 'PUT');
                    this.axios
                        .post(this.axios.defaults.baseURL + 'admin/stocks/' + this.$route.params.id, formData)
                        .then(response => {
                           if (response.data.message === 'success'){
                               this.$router.push({name: 'AdminBanner', params: {message: 'Успешно обновлен'}})
                           }

                        })
                        .catch(error => {
                            console.log(error);
                        })
                }
            },

            handleFileUpload() {
                this.banner = this.$refs.banner.files[0];
            }
        }
    }
</script>

<style scoped lang="scss">
    .image-cart {
        width: 100%;
        height: 200px;
        object-fit: contain;
        object-position: center;
    }

    .buttons {
        margin: 25px 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/app/admin/Banner/insert.vue